import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "name", "description", "amount", "currency", "expiration"]

  applySelected() {
    const selectedOption = this.selectTarget.selectedOptions[0]
    if (!selectedOption) {
      return
    }

    if (!selectedOption.value) {
      this.clearFields()
      return
    }

    this.nameTarget.value = selectedOption.dataset.name || ""
    this.descriptionTarget.value = selectedOption.dataset.description || ""
    this.amountTarget.value = selectedOption.dataset.amount || ""
    this.currencyTarget.value = selectedOption.dataset.currencyId || ""

    const expirationMinutes = selectedOption.dataset.expirationMinutes
    this.applyExpiration(expirationMinutes)
  }

  startFromScratch(event) {
    event.preventDefault()
    this.selectTarget.value = ""
    this.clearFields()
    this.nameTarget.focus()
  }

  clearFields() {
    this.nameTarget.value = ""
    this.descriptionTarget.value = ""
    this.amountTarget.value = ""
    this.currencyTarget.value = ""
    this.applyExpiration("")
  }

  applyExpiration(minutes) {
    const expirationContainer = this.element.querySelector('[data-controller~="expiration-presets"]')
    if (!expirationContainer) {
      this.expirationTarget.value = minutes || ""
      return
    }

    if (!minutes) {
      this.clickExpirationButton(expirationContainer, "0")
      return
    }

    if (!this.clickExpirationButton(expirationContainer, minutes)) {
      this.clickExpirationButton(expirationContainer, "custom")
      this.expirationTarget.value = minutes
      this.expirationTarget.dispatchEvent(new Event("input", { bubbles: true }))
    }
  }

  clickExpirationButton(container, minutesValue) {
    const button = container.querySelector(`[data-minutes="${minutesValue}"]`)
    if (!button) {
      return false
    }

    button.click()
    return true
  }
}
